import PropTypes from 'prop-types';
import React from 'react';
import StockOrb from './StockOrb';

const StockStatusIndicator = ({ status, text, storeName }) => {
  if (storeName && storeName !== 'nätbutik') return null;
  const notifyWhenBack = text?.includes('Beställningsvara');
  return (
    <>
      <p
        className="stock-status-indicator"
        style={{
          margin: '0',
          marginTop: '0.25rem',
          fontSize: '14px',
          color: '#555',
          lineHeight: '140%',
        }}
      >
        <StockOrb
          status={
            storeName && storeName !== 'nätbutik'
              ? 'inStock'
              : notifyWhenBack
              ? 'notifyWhenBack'
              : status
          }
        />
        {storeName && storeName !== 'nätbutik'
          ? `I lager i ${storeName}`
          : text}
      </p>
    </>
  );
};

StockStatusIndicator.propTypes = {
  status: PropTypes.oneOf(['inStock', 'outOfStock', 'notifyWhenBack']),
  text: PropTypes.string,
};

export default StockStatusIndicator;
